module.exports = __webpack_public_path__ + "images/help/icon-twr44-f066c7013eab3bd7b76289c938188215.png";